import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'lingui-react';

import messages from './messages';

function generateWidgetHeaderNote({ unreadNotesCount }) {
  return unreadNotesCount ? ` (${unreadNotesCount} unread)` : '';
}

function NotesWidgetHeader({ info }) {
  return <Trans id={messages.title} values={{ count: generateWidgetHeaderNote(info) }} />;
}

NotesWidgetHeader.propTypes = {
  info: PropTypes.shape({
    unreadNotesCount: PropTypes.number,
  }).isRequired,
};

export default NotesWidgetHeader;



// WEBPACK FOOTER //
// ./compositions/NotesWidget/NotesWidgetHeader.js